import React, { Component } from "react";
import List from "@material-ui/core/List";
import { Skeleton } from "@material-ui/lab";
import { Box } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import fetchAPI from "../../../../../../components/utils/fetchAPI";

import { FixedSizeList } from "react-window";
import renderRow from "./renderRow";
import HeaderCard from "./HeaderCard";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
});

const typeClients = ["clients_exception", "clients"];

class SimpleCard extends Component {
  state = {
    // data: [],
    filter: [],
    loading: true,
    isCheck: [],
    rowsChecked: {},
    yellow: this.props.yellow !== "undefined" ? this.props.yellow : false,
    grey: this.props.grey !== "undefined" ? this.props.grey : false,
    openPrueba: false,
    desplegarprueba: [],
    flagMasive: [],
    property: this.props.property,
    count: this.props.count,
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  HeaderCardRef = React.createRef(null);

  CARD_ID = null;
  CARD_TITLE = null;
  DATA = [];
  FILTER = [];
  IS_CHECKED_ALL = false;

  componentDidMount = async () => {
    if (this.props.service && !typeClients.includes(this.state.property))
      await this.getData();
    else {
      this.setDataState(this.props.card.rules);
      this.handleSelectAll({ target: { checked: true } });
      this.setState({ loading: false });
    }
  };

  setDataState = (data, cb) => {
    this.DATA = data;
    this.setState(
      {
        filter: data,
      },
      () => {
        cb && cb();
      }
    );
  };

  getData = async () => {
    await fetchAPI({
      service: this.props.service,
      protocol: "GET",
      callbackThen: (response) => {
        this.setDataState(response);
        this.setState({ loading: false });
      },
    });
  };

  handleSelectAll = (e) => {
    const newData = this.DATA;
    const newFilter = this.state.filter.map((element) => {
      const index = newData.findIndex((ele) => ele.id === element.id);
      if (e.target.checked) {
        if (!element.checked) {
          element.checked = true;
          newData[index].checked = true;
        }
      } else {
        if (element.checked) {
          element.checked = false;
          newData[index].checked = false;
        }
      }
      return element;
    });

    this.setState({
      filter: newFilter,
    });
    this.DATA = newData;
  };

  isCheckAll = () => {
    let isCheckAll = false;
    if (!this.state.filter) isCheckAll = false;
    if (this.state.filter && this.state.filter.length === 0) isCheckAll = false;
    if (this.state.filter.length > 0)
      isCheckAll =
        this.state.filter.filter((element) => element.checked).length ===
        this.state.filter.length;

    this.IS_CHECKED_ALL = isCheckAll;

    this.HeaderCardRef.current?.setChecked(isCheckAll);
  };

  handleSearch = (show) => {
    const label = document.getElementById(
      `exclutions__container-title-card-${this.props.card.id}`
    );

    const buttonSearch = document.getElementById(
      `exclutions__container-button-search-${this.props.card.id}`
    );
    const inputSearch = document.getElementById(
      `exclutions__container-input-search-${this.props.card.id}`
    );

    label.style.display = show ? "none" : "block";
    buttonSearch.style.display = show ? "none" : "flex";
    inputSearch.style.display = !show ? "none" : "block";

    if (!show) {
      document.getElementById(
        `exclutions__input-search-${this.props.card.id}`
      ).value = null;
      this.searchValues("");
    }
  };

  searchValues = (value) => {
    this.setState({
      filter:
        value === null || value === "" || value === ""
          ? this.DATA
          : this.DATA.filter((element) =>
              (element.id + element.name)
                .toLowerCase()
                .includes(value.toLowerCase())
            ),
    });
  };

  handleInput = (e) => {
    let text = e.target.value;
    if (text !== "" && text.length > 0) {
      this.searchValues(text);
    }
    this.isCheckAll();
  };

  masiveCheck = (arrKeys) => {
    if (Array.isArray(arrKeys) && arrKeys.length > 0)
      this.handleSearch(false); // Cierra todos los buscadores de las cards

    this.setState({
      flagMasive: arrKeys,
    });

    let mapped = arrKeys;
    if (this.props.clients && arrKeys) {
      this.setDataState(
        arrKeys.map((element) => {
          return {
            ...element,
            id: element.cust_no,
            checked: true,
          };
        }),
        this.isCheckAll
      );
    } else {
      this.setDataState(
        this.DATA.map((element) => {
          if (mapped && mapped.length > 0)
            element.checked = mapped.includes(element.id);
          else element.checked = false;
          return element;
        }),
        this.isCheckAll
      );
    }
  };

  emiteRules = () => {
    const keys = {};
    keys[this.props.property] = this.DATA.filter((ele) => ele.checked).map(
      (ele) => ele.id
    );
    this.props.setRules([this.props.property], keys);
  };

  // add or remove keys checked
  handleCheck = (event, id) => {
    const indexFilter = this.state.filter.findIndex(
      (element) => element.id === id
    );
    const indexData = this.DATA.findIndex((element) => element.id === id);
    const newFilter = this.state.filter;
    const newData = this.DATA;
    const checked = event.target.checked;
    newFilter[indexFilter] = {
      ...newFilter[indexFilter],
      checked,
    };
    newData[indexData] = {
      ...newData[indexData],
      checked,
    };
    this.setState({
      filter: newFilter,
    });
    this.DATA = newData;

    this.isCheckAll();
  };

  render() {
    this.CARD_ID = this.props.card.id;
    this.CARD_TITLE = this.props.card.title;
    const idCardContainer = "card-exclutions-container-" + this.props.card.id;
    if (this.state.flagMasive !== this.props.card.rules) {
      this.masiveCheck(this.props.card.rules);
    }
    const classCard = this.state.yellow
      ? `exclutions__card exclutions__card--clients-type`
      : this.state.grey
      ? `exclutions__card exclutions__card--zone`
      : `exclutions__card exclutions__card--sales-manager`;

    const idList = "card-exclutions-list-" + this.props.card.id;

    //tamaño cards
    const styleBox = {
      height: "236px",
    };

    const subheaderList = (
      <HeaderCard
        ref={this.HeaderCardRef}
        CARD_ID={this.CARD_ID}
        IS_CHECKED_ALL={this.IS_CHECKED_ALL}
        CARD_TITLE={this.CARD_TITLE}
        handleSelectAll={this.handleSelectAll}
        handleInput={this.handleInput}
        handleSearch={this.handleSearch}
      ></HeaderCard>
    );

    return (
      <div id={idCardContainer} className={classCard}>
        <div className="exclutions__card__overlay"></div>
        <Box style={styleBox}>
          <List
            id={idList}
            subheader={subheaderList}
            style={{ overflow: "hidden", position: "relative" }}
          >
            {this.state.loading && (
              <>
                {Array(5)
                  .fill(2)
                  .map((x) => (
                    <Skeleton
                      key={`skeleton_${this.CARD_ID}_${x}`}
                      animation="wave"
                      height={"35px"}
                      style={{ marginLeft: "5px", marginRight: "5px" }}
                    />
                  ))}
              </>
            )}
            {/*listItems*/}

            <FixedSizeList
              height={180}
              width={360}
              itemSize={50}
              itemCount={this.state.filter.length}
              itemData={this.state.filter}
              overscanCount={2}
              style={{ position: "absolute", width: "100%", height: "80%" }}
            >
              {(props) =>
                renderRow({
                  ...props,
                  CARD_ID: this.CARD_ID,
                  handleCheck: this.handleCheck,
                  parentData: this.DATA,
                })
              }
            </FixedSizeList>
          </List>
        </Box>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(SimpleCard);
